import { LocalNotifications, ActionPerformed } from '@capacitor/local-notifications';
import router from '@/core/router';

export const CapacitorLocalNotificationsPlugin = {
  async install() {
    await LocalNotifications.schedule({
      notifications: [
        // {
        //   id: 10,
        //   title: 'Test',
        //   body: 'Test',
        //   schedule: {
        //     every: 'minute',
        //   },
        //   extra: {
        //     route: {
        //       path: '/video-bible',
        //       query: {
        //         ref: 'GEN:3:5',
        //       },
        //     },
        //   },
        // },
      ],
    });

    await LocalNotifications.addListener('localNotificationReceived', (event) => {
      console.log('Local notification triggered:', JSON.stringify(event));
    });

    await LocalNotifications.addListener('localNotificationActionPerformed', (action: ActionPerformed) => {
      console.log('Local notification action performed:', JSON.stringify(action));

      if (action.notification?.extra?.route) {
        router.push(action.notification.extra.route);
      }
    });
  },
};
